/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MoveToDetailsIconContainer from '../../../../Display/NDC/component/MoveToDetailsIconContainer/MoveToDetailsIconContainer';
import SearchComponent from '../../../../Display/NDC/component/NDCByDrugName/SearchComponent';
import TableComponent from '../../../../Display/NDC/component/NDCByDrugName/TableComponent';
import {
  checkClaimAndAddToDetailsTable,
  removeFromClaimDetailsTableData,
  setClaimDetailsTableData,
  setClaimErrorPopupMessage,
  setClaimLoading,
  setClaimSearchByDrugNameTableData,
} from '../../store/action';
import ClaimsDetailsTable from './ClaimsDetailsTable';

const SearchByDrugName = ({ fullScreen, setFullScreen, setError }) => {
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [leftGridFullScreen, setLeftGridFullScreen] = useState(false);
  const [rightGridFullScreen, setRightGridFullScreen] = useState(false);

  const searchByDrugNameTableData = useSelector(
    (state) => state.sharedState.NumberOfUnits.searchByDrugNameTableData
  );

  const addSingleRowToDetailsTable = () => {
    if (selectedRow.length === 0) {
      dispatch(setClaimErrorPopupMessage('Please select from the drug names'));
    } else {
      dispatch(setClaimErrorPopupMessage(null));
      dispatch(checkClaimAndAddToDetailsTable(selectedRow));
      gridApi.deselectAll();
    }
  };

  const addAllToDetailsTable = () => {
    if (searchByDrugNameTableData.length == 0) {
      dispatch(setClaimErrorPopupMessage('NDC not found'));
    } else {
      dispatch(setClaimErrorPopupMessage(null));
      dispatch(checkClaimAndAddToDetailsTable(searchByDrugNameTableData));
      gridApi.deselectAll();
    }
  };

  const loadingFunc = (value) => {
    dispatch(setClaimLoading(value));
  };

  const setClaimError = (message) => {
    dispatch(setClaimErrorPopupMessage(message));
  };

  const onSearchClick = (searchResult) => {
    if (!searchResult) {
      dispatch(setClaimErrorPopupMessage('NDC Not Found'));
    } else {
      dispatch(setClaimErrorPopupMessage(null));
    }

    dispatch(setClaimSearchByDrugNameTableData(searchResult || []));
    loadingFunc(false);
  };

  const handleFullScreenView = useCallback((screenView, type) => {
    setFullScreen(screenView);
    if (type === 'left') {
      setLeftGridFullScreen(screenView);
    } else if (type === 'right') {
      setRightGridFullScreen(screenView);
    }
  }, []);

  return (
    <>
      {!rightGridFullScreen && (
        <div
          className={`${
            leftGridFullScreen ? 'col-12' : 'col-5'
          } d-flex flex-column`}
        >
          {!leftGridFullScreen && (
            <SearchComponent
              callback={(result) => onSearchClick(result)}
              loadingFunc={loadingFunc}
              setError={setClaimError}
            />
          )}
          <TableComponent
            setSelectedRow={setSelectedRow}
            searchByDrugNameTableData={searchByDrugNameTableData}
            gridApi={gridApi}
            setGridApi={setGridApi}
            fullScreen={leftGridFullScreen}
            setFullScreen={(screenView) =>
              handleFullScreenView(screenView, 'left')
            }
          />
        </div>
      )}
      {!leftGridFullScreen && !rightGridFullScreen && (
        <div className="col-2 px-2">
          <MoveToDetailsIconContainer
            handleSingleMove={() => addSingleRowToDetailsTable()}
            handleAllMove={() => addAllToDetailsTable()}
            handleAllRemove={() => {
              dispatch(setClaimDetailsTableData([]));
            }}
            handleSingleRemove={() => {
              dispatch(removeFromClaimDetailsTableData());
            }}
          />
        </div>
      )}
      {!leftGridFullScreen && (
        <div
          className={`${
            rightGridFullScreen ? 'col-12' : 'col-5'
          } d-flex flex-column p-0`}
          style={{ marginTop: '16px' }}
        >
          <ClaimsDetailsTable
            fullScreen={rightGridFullScreen}
            setFullScreen={(screenView) =>
              handleFullScreenView(screenView, 'right')
            }
            setError={setError}
          />
        </div>
      )}
    </>
  );
};

export default SearchByDrugName;
